import { useCallback } from 'react';

/** One click handler for a list of page buttons: each names its page in `data-page`. */
const usePageSelect = onSelectPage =>
  useCallback(event => onSelectPage(Number(event.currentTarget.dataset.page)), [onSelectPage]);

export default usePageSelect;
